import React from 'react'
import { TextField, TextFieldProps } from 'react-admin'
import LocalizedFieldGeneric from './LocalizedField'

type Props = Omit<TextFieldProps, 'source'> & {
  source: string
  children: React.ReactElement
}

type LocalizedTextFieldProps = Omit<Props, 'children'>

const LocalizedField = (props: Props) => LocalizedFieldGeneric<Props>(props)

const LocalizedTextField: React.FC<LocalizedTextFieldProps> = (props) => (
  <LocalizedField {...props}>
    <TextField />
  </LocalizedField>
)

export default LocalizedTextField
